/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function BellIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "bell", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M6.5 12C6.5 15 6.5 15.5 5.5 17V17.5H19.5V17C18.5 15.5 18.5 15 18.5 12C18.5 8 16.5 5.5 12.5 5.5C8.5 5.5 6.5 8 6.5 12Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10.5 17.5V18.5C10.5 20 11.5 20.5 12.5 20.5C13.5 20.5 14.5 20 14.5 18.5V17.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(BellIcon);
export default ForwardRef;
//# sourceMappingURL=bellIcon.js.map